import { useRef as l, useCallback as r, useEffect as u } from "react";
const f = ({
  disabled: i,
  readOnly: c,
  setShowMenu: n
}) => {
  const t = l(null), e = r((s) => {
    t.current?.contains(s.target) || n(!1);
  }, []);
  return u(() => (window.addEventListener("click", e), () => {
    window.removeEventListener("click", e);
  }), [e]), {
    inputRef: t,
    handleInputClick: () => {
      !i && !c && n(!0);
    }
  };
};
export {
  f as useSelect
};
